<template>
  <div class="neitui-zhiwei">
    <c-table ref="table" :columns="columns" url="/neitui2">
      <el-table-column slot="zhiwei_name" label="职位名" class-name="pointer" width="160">
        <template v-slot="{row}">
          <div @click="jobInfo(row)">
            <span>{{row.zhiwei_name}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column slot="bumen" show-overflow-tooltip label="部门">
        <template v-slot="{row}">
          <span>{{row | bumen}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="shangchuan" label="我要推荐">
        <template v-slot="{row}">
          <el-button size="mini" @click="upload(row)" :loading="row.loading">上传</el-button>
        </template>
      </el-table-column>
      <el-table-column slot="caozuo" label="操作" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" @click="jobInfo(row)">岗位描述</el-button>
        </template>
      </el-table-column>
    </c-table>
    <el-upload
      style="display:none;"
      ref="upload"
      :show-file-list="false"
      action="/api/neitui/uploadjianli"
      :data="{zhiwei_id:currentJob.zhiwei_id}"
      :before-upload="() => $set(currentJob, 'loading', true)"
      :on-success="onSuccess"
      :on-error="onError"
    ></el-upload>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'neitui-zhiwei',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      columns: [
        { slot: 'zhiwei_name' },
        { slot: 'bumen' },
        { prop: 'zhiwei_jibie', label: '级别', width: 100 },
        { prop: 'zhiwei_number', label: '人数', width: 80 },
        { slot: 'shangchuan' },
        { slot: 'caozuo' }
      ],
      currentJob: {}
    }
  },
  methods: {
    upload (job) {
      this.currentJob = job
      this.$refs.upload.$refs[ 'upload-inner' ].$refs.input.click()
    },
    onSuccess () {
      this.currentJob.loading = false
      this.$notify.success({
        title: '成功',
        message: '上传成功'
      })
    },
    onError () {
      this.$notify.error({
        title: '失败',
        message: '上传失败'
      })
    },
    operate (row, event, operate = 'up') {
      const key = operate === 'up' ? 'zhiwei_zhiding' : 'zhiwei_neitui'
      this.$_confirm({
        operateText: event.target.innerText,
        name: row.zhiwei_name,
        operate: () =>
          this.$http.post(`/zhaopin/zhiwei/${row[ key ] === 1 ? 'not' : ''}${operate}2`, {
            zhiwei_id: row.zhiwei_id
          }),
        callback () {
          row[ key ] = row[ key ] === 1 ? 0 : 1
        }
      })
    }
  }
}
</script>

<style lang="scss">
</style>
